import logo from "../../Assets/images/logo.png";

export const ThankYou = () => {
  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <a href="http://iris-solar.com/" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </a>
          </div>
          <div className="authcardmain authform pt-3 mt-5 white-font">
            <h1 className="mb-3 text-center">Welcome!</h1>
            <label className="white-font mb-3 mt-2">Thank you for registering with us! We’re excited to have you on board.</label>
            <label className="white-font mb-3">Your account is currently under review by our admin team and will be activated shortly. A confirmation email will be sent to your registered email address once the approval process is complete.</label>
            {/* <label className="white-font mb-4">We appreciate your patience and look forward to serving you.</label> */}
            <a href="http://iris-solar.com/" className="btn-primary-custom w-100 text-center">
              Visit Our Website
            </a>
            <div className="small white-font mt-2 text-center">
              &copy; 2025 Iris Solar. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
